import { NewBuildingConstructionRoute } from '@search/nb-routes/src/NewBuildingConstructionRoute';

import initBrowserApp from '../../../../client/common/libs/init-browser-app';
import NotFoundPage from '../../../../client/desktop/components/NotFoundPage';

import instanceConfig from '../../config';

import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import Mortgage from '../../components/desktop/Mortgage';
import { linkBuilder } from '../../routes/routes';
import NewBuildingConstructionPage from '../../../../client/desktop/components/NewBuildingConstructionPage';
import NewBuildingConstructionPageSeo from '../../../../client/common/components/NewBuildingConstructionPageSeo';
import NewBuildingCardRightBlock from '../../components/desktop/NewBuildingCard/NewBuildingCardRightBlock';

import '../../components/common/styles.css';
import '../../components/desktop/styles.css';

initBrowserApp({
    routes: [
        {
            type: 'NewBuildingConstructionRoute',
            route: NewBuildingConstructionRoute,
            Component: NewBuildingConstructionPage,
            SeoComponent: NewBuildingConstructionPageSeo
        }
    ],
    linkBuilder,
    instanceConfig,
    components: {
        Header,
        Footer,
        Mortgage,
        NotFoundPage,
        NewBuildingCardRightBlock
    }
});

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
// @ts-ignore
if (typeof module.hot === 'object') {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    module.hot.accept();
}
